export default __webpack_public_path__ + "c7fa7744af59c3e7f0db4f6ed404e334.png";